module.exports = __webpack_public_path__ + "static/ormeggio-logo-1f49511450f0b1d38d18325acebe8bbe.jpg";